import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { axios } from '@utils/lib';
import { Enums, Paths, Value } from '@utils/constants';
import { IListRes } from '@interfaces/apis/response-data';

export const getPreRegistrationDetailsAsync = createAsyncThunk(
  'api/getPreRegistrationDetailsAsync',
  async (query: IPreRegistrationDetail, { rejectWithValue, dispatch }) => {
    const { id } = query;
    dispatch(addLoading());
    try {
      const result = await axios.request<IPreRegistrationDetailRes>(
        Enums.HTTP_METHOD.GET,
        Paths.PRE_REGISTRATION_DETAIL.replace(':id', id)
      );
      return result.data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const updatePreRegistrationDetailsAsync = createAsyncThunk(
  'api/updatePreRegistrationDetailsAsync',
  async (
    query: IUpdatePreRegistrationDetail,
    { rejectWithValue, dispatch }
  ) => {
    const { id, isAlert, note } = query;
    const body = {
      note,
      isAlert,
    };
    dispatch(addLoading());
    try {
      const result = await axios.request<IPreRegistrationDetailRes>(
        Enums.HTTP_METHOD.PATCH,
        Paths.PRE_REGISTRATION_DETAIL.replace(':id', id),
        body
      );
      return result.data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const getPreRegistrationListAsync = createAsyncThunk(
  'api/getPreRegistrationListAsync',
  async (query: IPreRegistrationListQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const searchQuery: Record<string, string> = {
      page: String(query.page ?? Value.TABLE_PAGE_INIT),
    };
    if (query.companyName) searchQuery.companyName = query.companyName;
    if (query.fullNameUser) searchQuery.fullNameUser = query.fullNameUser;
    if (query.phoneNumber) searchQuery.phoneNumber = query.phoneNumber;
    if (query.registerDateStart)
      searchQuery.registerDateStart = query.registerDateStart;
    if (query.registerDateEnd)
      searchQuery.registerDateEnd = query.registerDateEnd;

    searchQuery.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const params = new URLSearchParams(searchQuery).toString();
    try {
      const { data } = await axios.request<IListRes<IPreRegistrationList>>(
        Enums.HTTP_METHOD.GET,
        Paths.PREREGISTRATION_LIST + '?' + params
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const approvePreRegistrationDetailsAsync = createAsyncThunk(
  'api/approvePreRegistrationDetailsAsync',
  async (
    query: IApprovePreRegistrationDetail,
    { rejectWithValue, dispatch }
  ) => {
    const { id, status } = query;
    const body = {
      status,
    };
    dispatch(addLoading());
    try {
      const result = await axios.request<IApprovePreRegistrationRes>(
        Enums.HTTP_METHOD.PATCH,
        Paths.PRE_APPROVE_REGISTRATION_DETAIL.replace(':id', id),
        body
      );
      return result.data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const approveAllPreRegistrationAsync = createAsyncThunk(
  'api/approveAllPreRegistrationAsync',
  async (query: IApproveAllDriverBase, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const result = await axios.request<IApprovePreRegistrationRes>(
        Enums.HTTP_METHOD.PATCH,
        Paths.PRE_APPROVE_REGISTRATION,
        query
      );
      return result.data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const sendSmsAsync = createAsyncThunk(
  'api/sendSmsAsync',
  async (data: IResendVerifyPhone, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const result = await axios.request(
        Enums.HTTP_METHOD.POST,
        Paths.RESEND_VERIFY_PHONE,
        data
      );
      return result.data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const verifyPhoneDriverTmpAsync = createAsyncThunk(
  'api/verifyPhoneDriverTmpAsync',
  async (hashId: string, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PATCH,
        Paths.VERIFY_PHONE_DRIVER_TMP.replace(':hashId', hashId)
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);
